import { render } from "./StudentFinanceData.vue?vue&type=template&id=f4687692&scoped=true"
import script from "./StudentFinanceData.vue?vue&type=script&lang=js"
export * from "./StudentFinanceData.vue?vue&type=script&lang=js"

import "./StudentFinanceData.vue?vue&type=style&index=0&id=f4687692&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-student/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4687692"]])

export default __exports__